import { AxiosApiBase } from './axiosApiBase';
import { KycResponse, IKycSubmitRequest } from '../models/dtos/kyc';

export class KycApi extends AxiosApiBase {
  async getKycStatus(borrowerId: number): Promise<KycResponse> {
    return await this.get<KycResponse>(`/api/v1/Kyc?borrowerId=${borrowerId}`);
  }

  // PUT /api/v1/Kyc — multipart/form-data. Assembles `details`, `borrowerId`
  // and the `documents[]` list into the field-name shape the ASP.NET model
  // binder expects (`Documents[i].Field`). Axios sets the multipart boundary
  // automatically for a FormData body.
  async submitKyc(request: IKycSubmitRequest): Promise<KycResponse> {
    const form = new FormData();
    form.append('Details', request.details);
    form.append('BorrowerId', String(request.borrowerId));
    request.documents.forEach((doc, i) => {
      form.append(`Documents[${i}].DocumentTypeId`, String(doc.documentTypeId));
      form.append(`Documents[${i}].LegalIdTypeId`, String(doc.legalIdTypeId));
      form.append(`Documents[${i}].DocumentIdNumber`, doc.documentIdNumber);
      form.append(`Documents[${i}].File`, doc.file);
    });
    return await this.put<KycResponse>(`/api/v1/Kyc`, form);
  }
}
